<svg width="24" height="25" fill="none" version="1.1" viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
 <path d="m12 4.7168v15m7.5-7.5h-15" stroke="#322D32" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
</svg>
